import { env } from "@/configs/env";

import { createRequestInstance } from "./factory";

/**
 * LMS backend uchun yagona umumiy so'rov instansiyasi.
 * Bazaviy manzil `/api/v1` global prefiksini o'z ichiga oladi.
 */
export const request = createRequestInstance({
  baseURL: env.API_BASE_URL,
});
